module.exports = __webpack_public_path__ + "img/gy.ec98b01f.svg";